/**************************************************************************
Name:         	event.js
Description:  	Event scripting
Date Created: 	08.30.2019 Brynn Chivers
Modified:
**************************************************************************/

loadEvents.push(function() {
	//var originalText;
	$(".iconLink.pdf").mouseenter(function() {
		originalText = $(this).text();
		$(this).text("PDF");
	})
	.mouseleave(function() {
		$(this).text(originalText);
	});
});